<template>
    <div>
        <div class="row shadow-v2" style="height: 55px;">
            <div class="d-flex col-9 ps-4">
                <img class="logo_nova hover-effect mt-3" src="@/assets/logo_nova.svg" height="25" title="GNP" />
            </div>
            <div class="col-3 pt-2 d-flex pb-2" style="flex-direction: row-reverse;">
                <button class="btn-new-crud me-3" @click="abreModalTypes"><i class="fas fa-cloud-download-alt pe-2"></i>Download Personalizado</button>
            </div>
        </div>
        <div id="app" class="text-center" style="width: 100%" :style="dinamicWidth">
            <div class="mt-0">
                <iframe id="FrameDocumento" width="100" frameborder="0" class="col-12" style="overflow: auto; padding: 0; background-color: #C4C4C4; box-shadow: inset 5px 0px 10px rgba(0, 0, 0, 0.25); height: calc(100vh - 3.2rem);"></iframe>
            </div>
        </div>
        <modal-warper target="ModalExportaRelatorio" :show="isOpenModalExportaRelatorio" @close="(isOpenModalExportaRelatorio = false)">
            <Modal id="ModalExportaRelatorio" :size="''" :open="isOpenModalExportaRelatorio"
                   :customSizeWid="'width:600px;margin: 0 auto;padding-top:4rem;'" :FooterDefault="false" :ClassBG="true"
                   :customModalBody="'min-height:calc(100vh - 72rem); overflow: unset;'">
                <template v-slot:header>
                    <h6 class="modal-title">
                        Download Personalizado
                    </h6>
                    <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                    </button>
                </template>
                <template v-slot:body>
                    <div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Tipo de Arquivo</label>
                                <vue-select :options="tipos_arquivo"
                                            :label-by="(t) => (t.nmTipo)" v-model="tipo_arquivo"
                                            placeholder="Digite o nome do tipo e selecione"
                                            search-placeholder="Pesquise" searchable close-on-select clear-on-select :min="1"
                                            class="form-control shadow-v2"  :style="{ 'z-index': 100001 }">
                                </vue-select>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-slot:footer>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                            Fechar
                        </button>
                        <button type="button" class="btn btn-red-v2 v4" @click="exportar">
                            <i class="fas fa-cloud-download-alt pe-2"></i>
                            Realizar Download
                        </button>
                    </div>
                </template>
            </Modal>
        </modal-warper>
    </div>
</template>

<script>

    import CryptoJS from 'crypto-js';
    import axios from 'axios';
    import $ from "jquery";
    import Modal from "@/components/App/Modal.vue";
    import ModalWarper from "@/components/App/ModalWarper.vue";
    import VueNextSelect from "vue-next-select";
    import "vue-next-select/dist/index.min.css";

    export default {
        name: 'VisualizadorReports',
        components: {
            ModalWarper,
            Modal,
            "vue-select": VueNextSelect,
        },
        props: {
        },
        data() {
            return {
                dinamicHeightSize: '',
                dinamicBotton: '',
                dinamicWidth: '',
                hash: '',
                reports: {},
                tipos_arquivo: [{ idTipo: 0, nmTipo: 'Pdf' }, { idTipo: 1, nmTipo: 'Word' }, { idTipo: 2, nmTipo: 'HTML' }, { idTipo: 3, nmTipo: 'Excel' }, { idTipo: 4, nmTipo: 'ExcelData' }, { idTipo: 5, nmTipo: 'Xml' }, { idTipo: 6, nmTipo: 'Text' }],
                tipo_arquivo: {},
                isOpenModalExportaRelatorio: false,
            }
        },
        methods: {
            base64toBlob(base64Data, contentType) {
                contentType = contentType || '';
                var sliceSize = 1024;
                var byteCharacters = atob(base64Data);
                var bytesLength = byteCharacters.length;
                var slicesCount = Math.ceil(bytesLength / sliceSize);
                var byteArrays = new Array(slicesCount);

                for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
                    var begin = sliceIndex * sliceSize;
                    var end = Math.min(begin + sliceSize, bytesLength);

                    var bytes = new Array(end - begin);
                    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                        bytes[i] = byteCharacters[offset].charCodeAt(0);
                    }
                    byteArrays[sliceIndex] = new Uint8Array(bytes);
                }
                var artchive = new Blob(byteArrays, { type: contentType })
                return artchive;
            },
            updateSizeDinamic() {
                if (window.innerWidth <= 1400) {
                    this.dinamicHeightSize = 'height:643px !important'
                    this.dinamicBotton = 'width: -webkit-fill-available;height: 40px;'
                } else if (window.innerWidth >= 3500) {
                    this.dinamicHeightSize = 'height:2000px !important'
                    this.dinamicBotton = ''
                    this.dinamicWidth = 'max-width:3500px'
                } else {
                    this.dinamicHeightSize = 'height:840px !important'
                    this.dinamicBotton = ''
                }
            },
            abreModalTypes() {
                this.isOpenModalExportaRelatorio = true;
            },
            carrega_reports() {
                let $this = this;

                (async () => {
                    try {
                        const response = await axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Reports/PostGeraReport', $this.reports, { headers: {} });
                        var file = window.URL.createObjectURL($this.base64toBlob(response.data, 'application/pdf'));
                        $("#FrameDocumento").attr("src", file);
                    } catch (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    }
                })();
            },
            exportar() {
                let $this = this;

                if ($this.tipo_arquivo.idTipo >= 0) {
                    $this.reports.type = $this.tipo_arquivo.idTipo;
                    (async () => {
                        try {
                            const response = await axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Reports/PostGeraReport', $this.reports, { headers: {} });
                            let blob = null;
                            let url = null;
                            let link = null;

                            switch ($this.tipo_arquivo.idTipo) {
                                case 0:
                                    blob = $this.base64toBlob(response.data, 'application/pdf');
                                    url = window.URL.createObjectURL(blob);
                                    link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'document.pdf';
                                    break;

                                case 1:
                                    blob = $this.base64toBlob(response.data, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
                                    url = window.URL.createObjectURL(blob);
                                    link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'document.docx';
                                    break;

                                case 2:
                                    blob = $this.base64toBlob(response.data, 'text/html');
                                    url = window.URL.createObjectURL(blob);
                                    link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'document.html';
                                    break;

                                case 3:
                                    blob = $this.base64toBlob(response.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                                    url = window.URL.createObjectURL(blob);
                                    link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'document.xlsx';
                                    break;

                                case 4:
                                    blob = $this.base64toBlob(response.data, 'application/vnd.ms-excel');
                                    url = window.URL.createObjectURL(blob);
                                    link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'document.xls';
                                    break;

                                case 5:
                                    blob = $this.base64toBlob(response.data, 'application/xml');
                                    url = window.URL.createObjectURL(blob);
                                    link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'document.xml';
                                    break;

                                case 6:
                                    blob = $this.base64toBlob(response.data, 'text/plain');
                                    url = window.URL.createObjectURL(blob);
                                    link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'document.txt';
                                    break;

                                default:
                                    blob = $this.base64toBlob(response.data, 'application/pdf');
                                    url = window.URL.createObjectURL(blob);
                                    link = document.createElement('a');
                                    link.href = url;
                                    link.download = 'document.pdf';
                            }

                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            $this.isOpenModalExportaRelatorio = false;

                        } catch (error) {
                            let msg = 'Ocorreu um erro inesperado';
                            if (error.response) {
                                msg = error.response.data.errors ? error.response.data.errors[0] : error.response.data.msg;
                            }
                            $this.$toast.show('alert', msg, true);
                        }
                    })();
                } else { $this.$toast.show('alert', 'Selecione um tipo de arquivo.', true); }
            }


        },
        mounted() {
            this.hash = this.$route.query.hash || '';

            if (this.hash != '' || this.hash != null) {
                const decryptedData = CryptoJS.AES.decrypt(this.hash, 'reports_gnp').toString(CryptoJS.enc.Utf8);

                if (decryptedData != '' && decryptedData != null) {
                    this.reports = JSON.parse(decryptedData);
                    this.reports.type = 0;
                    var currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.delete('hash');
                    window.history.replaceState({}, document.title, currentUrl.href);
                    this.carrega_reports();
                }

                this.updateSizeDinamic();
                window.addEventListener('resize', this.updateSizeDinamic);
            }
        },
        updated() {
            this.updateSizeDinamic();
        },
        watch: {},
    }

</script>

<style scoped lang="scss">
    .btn-new-crud {
    }
    .btn-red-v2 {
        padding: 0 20px 3px 20px;
    }
</style>